import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const TenantRepository = RepositoryFactory.get('tenant')

class TenantService {
  static async getHistoryAssignments (params) {
    try {
      return await TenantRepository.getHistoryAssignments(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getHistoryLesson (params) {
    try {
      return await TenantRepository.getHistoryLesson(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async downloadHistoryAssigments (params) {
    try {
      return await TenantRepository.downloadHistoryAssigments(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getLessonComparison (params) {
    try {
      return await TenantRepository.getLessonComparison(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getLevelSummary (params) {
    try {
      return await TenantRepository.getLevelSummary(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async downloadGeneralResults (params) {
    try {
      return await TenantRepository.downloadGeneralResults(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default TenantService
